import { fetchMakesAndModels } from 'lib/AutolistAPI';
import { createAction, createReducer, Dispatch } from '@reduxjs/toolkit';
import { isEmpty } from 'lodash';
import State from 'types/State';
import { MakeResponse } from 'types/MakeResponse';

const setMakesAndModels = createAction<Record<string, unknown>>('SET_MAKES_AND_MODELS');

const reducer = createReducer<MakeResponse[]>([], {
  [setMakesAndModels.type]: (state, action) => {
    return action.payload;
  },
});

export function loadMakesAndModels() {
  return async function makesAndModelsLoad(
    dispatch: Dispatch,
    getState: () => State
  ): Promise<void> {
    const { makesAndModels } = getState();

    if (isEmpty(makesAndModels)) {
      const response = await fetchMakesAndModels();
      dispatch(setMakesAndModels(response));
    }
  };
}

export { setMakesAndModels, reducer };
